import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from '../../../../../redux/store/store';
import LoadingSpinner from '../../../../../components/LoadingSpinner';
import { GetScheduleNotificationThunk, resetScheduleNotificationItemReducer } from '../../../../../redux/slices/components/ScheduleNotifications/scheduleNotificationsSlice';
import EditScheduleNotificationUpload from '../../../../../components/ScheduleNotification/EditScheduleNotificationUpload/EditScheduleNotificationUpload';
import { useTranslation } from 'react-i18next';

const EditScheduleNotificationUploadScreen = () => {

    const { t } = useTranslation()
    const { id } = useParams();
    const dispatch = useAppDispatch()

    const scheduleNotification = useSelector((state: RootState) => state.scheduleNotificationsData.scheduleNotification)
    const loadingInitalData = useSelector((state: RootState) => state.scheduleNotificationsData.loadingInitalData)

    useEffect(() => {
        
        if(id)
            dispatch( GetScheduleNotificationThunk(id) )

        return () => {
            dispatch( resetScheduleNotificationItemReducer() )
        }
    }, [dispatch, id])

    if(loadingInitalData){
        return (
            <LoadingSpinner fullPage={true} />
        )
    }

    if(!id)
        return(
            <></>
        )
    
    if(!scheduleNotification){
        return (
            <div className="center">
                <p className="fs-24">{t("Notifications:schedule:index:label_44")}</p>
            </div>
        )
    }

    return (
        <React.Fragment>
            <EditScheduleNotificationUpload id={id} scheduleNotification={scheduleNotification} />
        </React.Fragment>
    )
}

export default EditScheduleNotificationUploadScreen